import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { toast } from "sonner";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";
import {
  getDocumentationSettingYear,
  updateDocumentationSetting,
} from "../../../api/settings";
import { useEffect } from "react";

const DocumentationSetting = () => {
  const { selectedYear } = useAcademicYear();

  //Initialisation des state utilisés
  const createSchema = z.object({
    signatoryCertificate: z.string().nullable(),
    postSignatoryCertificate: z.string().nullable(),
  });

  type FormFields = z.infer<typeof createSchema>;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm<FormFields>({
    resolver: zodResolver(createSchema),
  });

  //Traitement après validation du formulaire de création d'un niveau
  const onSubmit: SubmitHandler<FormFields> = async (data) => {
    try {
      const finalData = {
        ...data,
      };
      // console.log(finalData)
      //Envoi des datas pour la MÀJ vers le backend
      await updateDocumentationSetting(finalData, selectedYear?.id);

      toast.success("Paramètres de documentation mis à jour !"); //Toast de succès
    } catch (error: any) {
      // Si erreur (Toast Error)
      toast.error(
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Une erreur s'est produit, Réessayer plus tard",
      );
    }
  };

  //On recupère la liste des Years en appelant sa fonction
  useEffect(() => {
    if (!selectedYear) return; // ✅ Ne rien faire si l'année académique n'es pas définie

    const fetchDocumentationSetting = async () => {
      try {
        const response = await getDocumentationSettingYear(selectedYear?.id);
        if (!response) {
          // Si aucune année trouvé
          throw new Error("Paramètre de documentation introuvable");
        }
        // console.log(response.data)
        reset({
          // Si année trouvé on rempli les champs du formulaire
          signatoryCertificate: response.data[0].signatoryCertificate,
          postSignatoryCertificate: response.data[0].postSignatoryCertificate,
        });
      } catch (error: any) {
        // Si erreur (Toast Error)
        toast.error(
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.message ||
        "Une erreur s'est produit, Réessayer plus tard",
      );
      }
    };

    fetchDocumentationSetting();
  }, [selectedYear]);

  return (
    <>
      <form className="needs-validation" onSubmit={handleSubmit(onSubmit)}>
        <div className="d-flex align-items-center justify-content-between flex-wrap border-bottom pt-3 mb-3">
          <div className="mb-3">
            <h5 className="mb-1">Préferences</h5>
            <p>
              Personnalisez le parcours et les paramètres de votre application
            </p>
          </div>
          <div className="mb-3">
            <button className="btn btn-primary" type="submit">
              Enregistrer
            </button>
          </div>
        </div>
        <div className="d-md-flex d-block">
          <div className="flex-fill">
            <div className="card">
              <div className="card-header">
                <h5>Signataires Certificat de fréquentation</h5>
              </div>
              <div className="card-body p-3 pb-0">
                <div className="row">
                  <div className="col-xxl-6 col-lg-6">
                    <div className="mb-3">
                      <label className="form-label"> Nom Signataire 1</label>
                      <div className="position-relative">
                        <div className="input-group">
                          <input
                            {...register("signatoryCertificate")}
                            type="text"
                            className={
                              errors.signatoryCertificate
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            placeholder="Ex: Dr Boubacar Sanogo"
                            aria-label="note_classe"
                            aria-describedby="basic-addon1"
                          />
                          <span className="input-group-text" id="basic-addon1">
                            <i className="ti ti-user-circle" />
                          </span>
                          {errors.signatoryCertificate && (
                            <div className="invalid-feedback">
                              {errors.signatoryCertificate.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-xxl-6 col-lg-6">
                    <div className="mb-3">
                      <label className="form-label">
                        {" "}
                        Fonction Signatire 1
                      </label>
                      <div className="position-relative">
                        <div className="input-group">
                          <input
                            {...register("postSignatoryCertificate")}
                            type="text"
                            className={
                              errors.postSignatoryCertificate
                                ? "form-control is-invalid"
                                : "form-control"
                            }
                            placeholder="Ex: Recteur"
                            aria-label="note_examen"
                            aria-describedby="basic-addon1"
                          />
                          <span className="input-group-text" id="basic-addon1">
                            <i className="ti ti-briefcase" />
                          </span>
                          {errors.postSignatoryCertificate && (
                            <div className="invalid-feedback">
                              {errors.postSignatoryCertificate.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default DocumentationSetting;
